import Alert, { AlertProps } from '@mui/material/Alert';
import { SxProps, Theme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { DaylitTheme } from '@lendica/theme';
import CelebrationIcon from '@mui/icons-material/Celebration';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CloseIcon from '@mui/icons-material/Close';
import { useContainerWidth } from '@lendica/hooks';

export const RebrandAlert = (props: AlertProps) => {
    const { sx, ...rest } = props;
    const baseSx: SxProps<Theme> = {
        'color': DaylitTheme.Palette.Burgundy,
        'backgroundColor': DaylitTheme.Palette.Dawn,
        '& .MuiAlert-icon': {
            color: DaylitTheme.Palette.Burgundy,
        },
    };
    const { isNarrow } = useContainerWidth();

    return (
        <Alert
            severity="info"
            sx={sx ? (Array.isArray(sx) ? [baseSx, ...sx] : [baseSx, sx]) : baseSx}
            icon={<CelebrationIcon color="inherit" fontSize="small" />}
            action={
                <span style={{ display: 'flex', minWidth: isNarrow ? 'auto' : '140px' }}>
                    {!isNarrow && (
                        <Button
                            href="https://daylit.com"
                            color="inherit"
                            size="small"
                            target="_blank"
                            rel="noopener noreferrer"
                            endIcon={<OpenInNewIcon fontSize="inherit" />}
                            sx={{
                                borderRadius: '4px',
                                fontWeight: 500,
                            }}
                        >
                            Learn more
                        </Button>
                    )}
                    {!!rest.onClose && (
                        <IconButton
                            color="inherit"
                            size="small"
                            aria-label="close"
                            onClick={rest.onClose}
                            sx={{
                                ml: 0.5,
                                borderRadius: '4px',
                            }}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    )}
                </span>
            }
            {...rest}
        >
            <a href="https://daylit.com" target="_blank" rel="noopener noreferrer">
                Lendica is now Daylit 🥳. Explore our new website and see our latest news and
                updates.
            </a>
        </Alert>
    );
};
